
export const translationDe = {
    translation: {
        entity: {
            data: 'Daten',
            job: 'Funktion',
            job_other: 'Funktionen',
            jobBoard: 'Gremium',
            jobBoard_other: 'Gremien',
            medusaJob: 'Medusa-Funktion',
            organization: 'Organisation',
            organization_other: 'Organisationen',
            section: 'Stufe',
            section_other: 'Stufen',
            member: 'Mitglied',
            memberContacts: 'Kontaktpersonen',
            memberContact: 'Kontaktperson',
            member_other: 'Mitglieder',
            relation: 'Beziehung',
            membership: 'Mitgliedschaft',
            dynamicFields: 'Freifelder',
            membershipRequest: 'Mitgliedschaftsanfrage',
            membershipRequests: 'Mitgliedschaftsanfragen',
            dsgvoRequest: 'DSGVO Anfrage',
            memberSection: 'Stufenzuordnung',
            membersection: 'Stufenzuordnung',
            memberJob: 'Funktionszuordnung',
            memberjob: 'Funktionszuordnung',
            memberRelation: 'Beziehung',
            memberrelation: 'Beziehung',
            memberPermission: 'Berechtigung',
            memberpermission: 'Berechtigung',
            permission_other: 'Berechtigungen',
            memberAward: 'Verleihung',
            memberaward: 'Verleihung',
            listHeader: 'Liste',
            listHeaders: 'Listen',
            listGenerator: 'Listengenerator',
            listMember: 'Listenmitglied',
            permission: 'Berechtigung',
            role: 'Rolle',
            award: 'Verleihung',
            award_other: 'Verleihungen',
            educationTrack: 'Ausbildungsplan',
            educationStep: 'Ausbildungsschritt',
            memberEducationTrack: 'Ausbildungsplan',
            membereducationtrack: 'Ausbildungsplan',
            memberEducationStep: 'Ausbildungsschritt',
            membereducationstep: 'Ausbildungsschritt',
            memberDescription: 'Notizen',
            registrationSnapshot: 'Registrierung',
            registrationRecord: 'Registrierungsdatensatz',
            scoutcardRequest: 'Scoutcard-Anfrage',
            dynamicField: 'Freifeld',
            dynamicfields: 'Freifeld',
            user: 'Benutzeraccount',
            memberPermissionApiKey: 'API-Key',
            memberDynamicFields: 'Freifelder',
            viewState: 'Ansicht',
            revision: 'Änderungshistorie',
            addressDataQuality: 'Qualitätsanalyse Adressdaten',
            memberDataQuality: 'Qualitätsanalyse Mitgliedsdaten',
            birthdayList: 'Geburtstagsliste',
            grinsRecord: 'GRINS Datensatz',
            registrationTransfer: 'Registrierungsübertragung',
            awardOverview: 'Übersicht Verleihungen',
            educationOverview: 'Übersicht Ausbildungen',
            charts: 'Statistiken',
            Organization: {
                MemberJob: 'Funktionszuordnung',
                MemberSection: 'Stufenzuordnung',
                Job: 'Funktion',
            },
            membershipDynamicField: 'Erweitertes Freifeld',
        },
        property: {
            general: {
                member: 'Mitglied',
                startDate: 'von',
                endDate: 'bis',
                startDateOnDate: 'von / am',
                validDates: "Gültig",
                dateRange: 'Zeitraum',
                unknownPeriod: 'Zeitraum unbekannt',
                code: 'Code',
                name: 'Name',
                abbreviation: 'Abkürzung',
                description: 'Bemerkung',
                comment: 'Anmerkung',
                active: 'aktiv',
                createDate: 'Erstellt am',
                updateDate: 'Geändert am',
                createdBy: 'Erstellt von',
                updatedBy: 'Geändert von',
            },
            memberRelation: {
                type: 'Art',
                relation: 'Beziehung',
                paymentRelevant: 'Beitragsrelevant',
                of: 'von',
            },
            membership: {
                organization: "Organisation",
                scoutstate: "Mitgliedschaftsart",
                registrationStatus: "Registrierstatus",
                feeClearedTroop: "Beitrag bezahlt",
                payment: "Mitgliedsbeitrag {{level}}",
                paymentFee: "Beitrag {{level}}",
                feeCleared: "Beitrag {{level}} bezahlt",
                paymentTroop: "Mitgliedsbeitrag Gruppe",
                paymentDivision: "Mitgliedsbeitrag Landesverband",
                paymentFederation: "Mitgliedsbeitrag Bundesverband",
                paymentFullpayer: "Scout-ID Vollzahler {{level}}",
                newsletter: "Zeitungsbezug {{level}}",
                newsletterShort: "Zeitung {{level}}",
                mailing: "Zusendungen {{level}}",
                mailingShort: "Zusendungen {{level}}",
                newsletterTroop: "Zeitung Gruppe",
                newsletterDivision: "Zeitung Landesverband",
                newsletterFederation: "Zeitung Bundesverband",
                currentOrganization: "Aktuelle Organisation",
                registrationOrganization: "Registrierende Organisation",
            },
            member: {
                scoutId: "Scout-ID",
                name: "Name",
                firstname: "Vorname",
                lastname: "Nachname",
                fullname: "Name",
                secondname: "Zweiter Vorname",
                birthdate: "Geburtsdatum",
                age: "Alter",
                sex: "Geschlecht",
                salutation: "Anrede",
                emailPrimary: "E-Mail",
                emailSecondary: "E-Mail 2",
                phoneMobile: "Telefon 2",
                phoneLine: "Telefon",
                titlePrefix: "Titel",
                titlePostfix: "Titel (nachgestellt)",
                nickname: "Spitzname",
                birthyear: "Geburtsjahr",
                nameOfBirth: "Geburtsname",
                scoutPromise: "Versprechen",
                scoutPromiseSmall: "WiWö Versprechen",
                profession: "Beruf",
                dayOfDeath: "Todesdatum",
                dayOfRetirement: "Austrittsdatum",
                addressaddition1: "Adresszusatz 1",
                addressaddition2: "Adresszusatz 2",
                street: "Straße",
                postcode: "PLZ",
                city: "Ort",
                province: "Bundesland",
                country: "Land",
                address: "Adresse",
                handicap: "PWA",
                description: "Notizen",
                descriptionPrivate: "Interne Notizen",
                descriptionPublic: "Öffentliche Notizen",
                permissions: "Berechtigungen",
                hasUseraccount: "Benutzerkonto",
                relations: 'Beziehungen',
                taxId: 'Steuernummer',
                lastLogin: 'Letzter Login',
                joinDate: 'Eintrittsdatum',

            },
            memberJob: {
                description: 'Beschreibung',
            },
            memberInfo: {
                age: "Alter",
                organization: "Registriert bei",
            },
            memberContact: {
                type: "Art",
                typeOf: "Art {{type}}",
                name: "Name {{type}}",
                email: "E-Mail {{type}}",
                phone: "Telefon {{type}}",
                address: "Adresse {{type}}",
                profession: "Beruf {{type}}",
            },
            organization: {
                foundationYear: 'Gründungsjahr',
                dissolvedYear: 'Jahr der Auflösung',
                zvr: 'ZVR-Zahl',
                dvr: 'DVR-Zahl',
                uid: 'UID-Nummer',
                street: 'Straße',
                postcode: 'PLZ',
                city: 'Ort',
                latitude: 'Breitengrad',
                longitude: 'Längengrad',
                locationIsoCode: 'ISO Code',
                province: 'Bundesland',
                country: 'Land',
                website: 'Webseite',
                emailPrimary: 'E-Mail',
                phone: 'Telefon',
                email: 'E-Mail',
                postReceiverScoutId: 'Postempfänger Scout-ID',
                dynamicField1: "Textfeld 1",
                dynamicField2: "Textfeld 2",
                dynamicField3: "Textfeld 3",
                dynamicField4: "Textfeld 4",
                dynamicField5: "Textfeld 5",
                checkField1: "Checkbox 1",
                checkField2: "Checkbox 2",
                checkField3: "Checkbox 3",
                checkField4: "Checkbox 4",
                checkField5: "Checkbox 5",
                dateField1: "Datum 1",
                dateField2: "Datum 2",
                dateField3: "Datum 3",
                dateField4: "Datum 4",
                dateField5: "Datum 5",
                memberFeeFull: "Mitgliedsbeitrag Vollzahler",
                memberFeeReduced: "Mitgliedsbeitrag Ermäßigt",
                memberFeeReduced2: "Mitgliedsbeitrag Ermäßigt 2",
                memberFeePwa: "Mitgliedsbeitrag PWA",
                memberFeeIndividual1: "Mitgliedsbeitrag Individual 1",
                memberFeeIndividual2: "Mitgliedsbeitrag Individual 2",
                memberFeeIndividual3: "Mitgliedsbeitrag Individual 3",
                newsletterFee: "Beitrag Zeitung",
                paymentCalculation: "Logik Mitgliedsbeitrag",
                newsletterCalculation: "Logik Zeitungsbezug",
                mailingCalculation: "Logik Mailing",
                postReceiver: "Postempfänger",
                sectionStartTime: "Beginn",
                sectionEndTime: "Ende",
                sectionWeekday: "Wochentag",
                sectionComment: "Kommentar",
                organizationLevel: "Ebene",
                biWeekday: "Wochentag Biber",
                wiwoWeekday: "Wochentag WiWö",
                guspWeekday: "Wochentag GuSp",
                caexWeekday: "Wochentag CaEx",
                raroWeekday: "Wochentag RaRo",
                biStartTime: "Beginn Biber",
                wiwoStartTime: "Beginn WiWö",
                guspStartTime: "Beginn GuSp",
                caexStartTime: "Beginn CaEx",
                raroStartTime: "Beginn RaRo",
                biEndTime: "Ende Biber",
                wiwoEndTime: "Ende WiWö",
                guspEndTime: "Ende GuSp",
                caexEndTime: "Ende CaEx",
                raroEndTime: "Ende RaRo",
                biComment: "Kommentar Biber",
                wiwoComment: "Kommentar WiWö",
                guspComment: "Kommentar GuSp",
                caexComment: "Kommentar CaEx",
                raroComment: "Kommentar RaRo",
                publishTimes: "Heimstundenzeiten öffentlich",
                color: "Farbe",
            },
            membershipRequest: {
                message: "Nachricht an Gruppe",
                requestingOrganization: "Anfragende Organisation",
                requestingUser: "Anfragendes Mitglied",
                finished: "Abgeschlossen",
                mainOrganization: "Organisation",
                replyMessage: "Antwortnachricht",
                incoming: "Eingehende",
                outgoing: "Ausgehende",
                for: "für",

            },
            listHeader: {
                scope: 'Bereich',
                type: 'Art',
                shareLevel: 'Freigabe',
                refresh: 'Automatisch aktualisieren',
                refreshDate: 'Letzte Aktualisierung',
            },
            listMember: {
                text1: 'Text 1',
                text2: 'Text 2',
                num1: 'Nummer 1',
                num2: 'Nummer 2',
                date1: 'Datum 1',
                date2: 'Datum 2',
                check1: 'Check 1',
                check2: 'Check 2',
                attended: 'Teilgenommen',
                assigned: 'Zugeordnet',
            },
            educationTrack: {
                groupName: 'Ausbildung',
                name: 'Name',
                organizationLevel: 'Ebene',
                manual: 'Individuelle Ausbildungsschritte',
            },
            educationStep: {
                name: 'Name',
            },
            memberEducationTrack: {
                description: 'Zusatz',
                startDate: 'Startdatum',
                completeDate: 'Abschlussdatum Plan',
            },
            memberEducationStep: {
                completeDate: 'Abschlussdatum',
                endDate: 'Abschlussdatum',
                description: 'Beschreibung',
                approveMember: 'Bestätigt von (Mitglied)',
                approver: 'Bestätigt von (Freitext)',
                approveOrganization: 'Bestätigt von (Organisation)',
            },
            registrationSnapshot: {
                type: 'Typ',
                createDate: 'Datum',
            },
            registrationRecord: {
                troopName: 'Gruppe',
                divisionName: 'Landesverband',
                federationName: 'Bundesverband',
                sectionMedusaAbbreviation: 'Stufe',
                troopJobs: 'Funktionen Gruppe',
                divisionJobs: 'Funktionen Landesverband',
                federationJobs: 'Funktionen Bundesverband',
                jobs: 'Funktionen',
                section: 'Stufe',
                changeType: 'Änderung',
                changeTypeDescription: 'Änderung zur letzten Registrierung',
                compareType: 'Vergleich',
                compareTypeDescription: 'Änderung zur Vergleichsregistrierung',
                registrationStatus: 'Registrierstatus',
                troopPayment: "Mitgliedsbeitrag Gruppe",
                paymentTroop: "Mitgliedsbeitrag Gruppe",
                divisionPayment: "Mitgliedsbeitrag Landesverband",
                paymentDivision: "Mitgliedsbeitrag Landesverband",
                federationPayment: "Mitgliedsbeitrag Bundesverband",
                paymentFederation: "Mitgliedsbeitrag Bundesverband",
                newsletterTroop: "Zeitungsbezug Gruppe",
                newsletterDivision: "Zeitungsbezug Landesverband",
                newsletterFederation: "Zeitungsbezug Bundesverband",
                relationlist: 'Beziehungen',
                createDate: 'Datenstand',
            },
            memberAward: {
                awardingDate: 'Verleihungsdatum',
                description: 'Beschreibung',
            },
            job: {
                board: 'Gremium',
                organizationLevel: 'Ebene',
                section: 'Stufe',
                medusaJob: 'Medusa-Funktion',
                leader: 'Leitung',
                educationApprover: 'Ausbildungsschritte bestätigen',
            },
            section: {
                parentSections: 'Übergeordnete Stufen',
            },
            viewState: {
                saveFilter: 'Filter speichern',
                saveColumns: 'Spalten speichern',
                saveSort: 'Sortierung speichern',
                savePageSize: 'Seitengröße speichern',
                shared: 'Einstellung in Organisation teilen',
                existingUuid: 'Vorhandene Ansicht',
            },
            quality: {
                message: "Info",
                messageType: "Typ",
                suggest: "Vorschlag",
                noSuggestion: "Kein Vorschlag in Adressregister gefunden",
            },
            revision: {
                changes: 'Änderungen',
                username: 'Benutzer',
                revisionInstant: 'Zeitpunkt',
            },
            user: {
                username: 'Benutzername',
                email: 'E-Mail',
            },
            memberPermission: {
                apiKeyExists: "API-Key vorhanden",
            },
            award: {
                organizationLevel: 'Ebene',
                sections: 'Stufen',
            },
            dsgvoRequest: {
                reason: 'Anfragegrund',
                message: 'Nachricht',
            },
            dynamicField: {
                datatype: 'Datentyp',
                organizationLevel: 'Ebene',
                organizationLevelDescription: 'Freifelder werden nur für die ausgewählte Organisationsebene angezeigt. Bei "Alle" werden die Freifelder für alle untergeordneten Ebenen angezeigt.',
                textValue: 'Text',
                numberValue: 'Nummer',
                boolValue: 'Checkbox',
                dateValue: 'Datum',
                readJobs: 'Leseberechtigung',
                writeJobs: 'Schreibberechtigung',
            },
            membershipDynamicField: {
                boolValue: 'Checkbox',
                dateValue: 'Datum',
                numberValue: 'Nummer',
                textValue: 'Text',
            }
        },
        action: {
            new: '{{entity}} anlegen',
            edit: '{{entity}} bearbeiten',
            create: 'anlegen',
            createNew: 'neu anlegen',
            add: '{{entity}} hinzufügen',
            addSingle: '{{entity}} hinzufügen (einzeln)',
            addMultiple: '{{entity}} hinzufügen (mehrere)',
            assign: '{{entity}} zuordnen',
            assigned: '{{entity}} zugeordnet',
            removed: '{{entity}} entfernt',
            delete: 'löschen',
            deleteEntity: '{{entity}} löschen',
            changed: '{{entity}} geändert',
            updated: '{{entity}} gespeichert',
            deleted: '{{entity}} gelöscht',
            created: '{{entity}} angelegt',
            added: '{{entity}} hinzugefügt',
            cloned: '{{entity}} dupliziert',
            refreshed: '{{entity}} aktualisiert',
            editRecord: 'bearbeiten',
            deleteRecord: 'löschen',
            saveRecord: 'speichern',
            save: 'Speichern',
            cancel: 'Abbrechen',
            ok: 'OK',
            change: 'Ändern',
            approve: 'Zustimmen',
            accept: 'Übernehmen',
            accepted: 'Akzeptiert',
            deny: 'Ablehnen',
            success: 'Erfolgreich',
            send: 'Absenden',
            showCompleted: 'abgeschlossene anzeigen',
            showInactive: 'inaktive anzeigen',
            request: 'Anfrage senden',
            requestOrOpen: 'Anfrage senden / öffnen',
            execute: 'ausführen',
            showResults: 'Ergebnisse anzeigen',
            downloadRequested: 'Download angefordert',
            downloadCompleted: 'Download abgeschlossen',
            createMember: 'Mitglied anlegen',
            createUser: 'Benutzeraccount anlegen',
            dsgvoDelete: 'DSGVO Löschen',
            saveView: 'Ansicht speichern',
            manageView: 'Ansichten bearbeiten...',
            restoreViews: 'Ansichten',
            login: "Login",
            logout: "Logout",
            createApiKey: "API-Key erstellen",
            deleteApiKey: "API-Key löschen",
            close: "Schließen",
            open: "Öffnen",
            record: {
                changed: 'Datensatz geändert',
            },
            listHeader: {
                clone: 'Liste duplizieren',
                cloneWithMember: 'Liste inkl. Mitglieder duplizieren',
                cloneWithMemberDetails: 'Liste inkl. Mitgliedsdaten duplizieren',
                refresh: 'Liste aktualisieren',
            },
            manualSnapshotCreationTriggered: 'Manuelle Snapshot-Erstellung gestartet',
            manualSnapshotCreationFailed: 'Manuelle Snapshot-Erstellung fehlgeschlagen: ',
            manualSnapshotCreationSuccess: 'Manuelle Snapshot-Erstellung erfolgreich',
            grinsExportCreationTriggered: 'GRINS Export-Erstellung gestartet',
            grinsExportCreationFailed: 'GRINS Export-Erstellung fehlgeschlagen: ',
            grinsExportCreationSuccess: 'GRINS Export-Erstellung erfolgreich',
            educationImported: 'Import erfolgreich',
            requestMembership: 'Mitgliedschaftsanfrage erstellen',
            resetMemberFeeCleared: 'Mitgliedsbeitrag bezahlt zurücksetzen',
            scoutcard: {
                export: {
                    full: 'Vollständig',
                    delta: 'Differenz',
                    daily: 'Aktuell',
                }
            },
            linkCopied: 'Link in Zwischenablage kopiert',
            apiLinkCopied: 'API-Link in Zwischenablage kopiert',
            reportInBackground: 'Der Bericht wird im Hintergrund erstellt. Du erhältst den Bericht per E-Mail.',
            listCreated: 'Die Liste wurde erstellt.',
            addedToList: 'Die Mitglieder wurden der Liste hinzugefügt.',
            download: 'Download',
            downloadCSV: 'CSV Download',
            downloadExcel: 'Excel Download',

        },
        button: {
            exportEmails: {
                MEMBER: 'Mitglieder',
                PARENTS: 'Kontaktpersonen',
                MEMBER_OR_PARENTS: 'Mitglieder oder Kontaktpersonen',
                MEMBER_AND_PARENTS: 'Mitglieder und Kontaktpersonen',
            },
            exportExcel: {
                SELECTED: 'aktuelle Spalten',
                ALL: 'alle Spalten',
            },
            registrationExport: {
                registration_finance_troop: "Beitragseinnahmen Gruppe",
                registration_finance_troops: "Beitragseinnahmen Gruppen",
                registration_finance_division: "Beitragseinnahmen Landesverband",
                registration_finance_division_TROOP: "Beitragsabgaben an Landesverband",
                registration_finance_division_DIVISION: "Beitragseinnahmen Landesverband",
                registration_finance_divisions: "Beitragseinnahmen Landesverbände",
                registration_finance_federation: "Beitragseinnahmen Landesverbände",
                registration_finance_federation_DIVISION: "Beitragsabgaben an Bundesverband",
                registration_finance_federation_FEDERATION: "Beitragseinnahmen Bundesverband",
                registration_finance_gildeverband: "Beitragseinnahmen Gildeverband",
                registration_job_section_division: "Funktionsübersicht",
                registration_job_section_federation: "Funktionsübersicht",
                registration_statistic_federation_troops: "Statistik Bundesverband - Gruppen",
                registration_statistic_federation_divisions: "Statistik Bundesverband - LV",
                registration_statistic_federation: "Statistik Bundesverband",
                registration_statistic_federation_divisions_ideell: "Statistik aller jemals erfassten Personen",
                registration_statistic_federation_divisions_history: "Statistik aller jemals registrierten Personen",
                registration_history: "Registrierung Historie (Gruppen)",
                registration_history_troops: "Registrierung Historie (Stufen)",
                scoreg_abrechnung: "SCOREG Abrechnung",
            },
            registrationSnapshot: {
                createManual: 'Snapshot erstellen',
            },
            grinsExport: {
                create: 'GRINS Export erstellen',
            },
            listExport: {
                single: 'Einzelne Liste',
                multi: 'Übersicht (mehrere Listen)',
            },
            report: "Berichte",
            toolbar: {
                columns: 'Spalten',
                filter: 'Filter',
            },
            migrations: {
                contactgroups: 'Kontaktgruppen migrieren',
                lists: 'Listen migrieren',
                events: 'Veranstaltungen migrieren',
                dynamicFields: 'Freifelder migrieren',
                dynamicFieldsComplete: 'Migration abschließen',
            },
            shareLink: 'UI Link teilen',
            shareApiLink: 'API Link teilen',
            exportColumns: 'Spalten exportieren',
            createList: 'Mitglieder in neue Liste hinzufügen',
            addToList: 'Mitglieder zu bestehender Liste hinzufügen',
        },
        title: {
            create: '{{entity}} anlegen',
            delete: '{{entity}} löschen',
            apiKeyCreated: 'API-Key erstellt',
            birthdayList: 'Geburtstagsliste',
            changePostreceiver: 'Postempfänger ändern',
            resetSettings: 'Einstellungen zurücksetzen',
        },
        question: {
            delete: '{{entity}} wirklich löschen?',
        },
        tooltip: {
            showInactive: 'inaktive {{entity}} anzeigen',
            list: {
                showInOverview: 'in Mitgliederliste anzeigen',
            },
            exportEmail: 'E-Mail',
            exportExcel: 'Excel-Export',
            actions: 'Aktionen',
            scoutcard: {
                export: {
                    full: 'Vollständigen Export erstellen',
                    delta: 'Differenzexport erstellen',
                    daily: 'Aktuellen Export erstellen',
                }
            },
            migrations: {
                dynamicFields: 'Migriert die Freifelder in die erweiterten Freifelder. Soll nur einmal pro Gruppe aufgerufen werden.',
                dynamicFieldsComplete: 'Schließt die Migration der Freifelder ab und löscht die alten Freifelder.',
            },
            changeInfo: 'eingetragen am {{createDate}} von {{createdBy}}, zuletzt geändert am {{updateDate}} von {{updatedBy}}',
        },
        menu: {
            members: {
                group: 'Mitglieder',
                overview: 'Übersicht',
                createSingle: 'Mitglied anlegen',
                createMultiple: "Mitglieder anlegen",
                listGenerator: "Listengenerator",
                birthdays: 'Geburtstagsliste',
            },
            education: "Ausbildung",
            awards: "Verleihungen",
            postreceiver: "Postempfänger",
            registration: "Registrierung",
            grins: "GRINS",
            grinsView: "Aktueller Stand",
            grinsExports: "Exporte",
            medusaImport: "Medusa Import",
            reports: "Berichte",
            help: "Hilfe",
            settings: "Einstellungen",
            permissionConfig: "Berechtigungen",
            quality: {
                group: "Qualitätsanalyse",
                member: "Mitglieder",
                address: "Adressen",
            },
            switchOrganization: "Organisation wechseln",
            organizations: 'Organisationen',
            member: {
                masterdata: "Stammdaten",
                dynamicFields: "Freifelder",
                enhancedDynamicFields: "Erweiterte Freifelder",
                user: "Benutzer",
                memberships: "Mitgliedschaften",
                registration: "Registrierung",
                currentMembership: "Aktuelle Mitgliedschaft",
                membershipSettings: "Einstellungen",
                section: "Stufen",
                job: "Funktionen",
                award: "Verleihungen",
                description: "Beschreibungen",
                images: "Bilder",
                education: "Ausbildung",
                permission: "Berechtigungen",
                relation: "Beziehungen",
                contact: "Kontaktpersonen",
                revision: "Änderungshistorie",
                info: "Info",
                pfadfinderlebenslauf: "Pfadfinderlebenslauf",
                datenblatt: "Datenblatt",
                listMember: "Listen",
            },
            organization: {
                revision: "Änderungshistorie",
                dsgvoRequest: "DSGVO Anfrage",
                migrations: "Datenmigrationen",
                dynamicFields: "Freifelder",
            },
            overview: 'Übersichten',
            bulkChangeSection: "Überstellung",
            lists: "Listen",
            calendar: "Kalender",
            charts: "Statistiken",
            userAvatar: {
                masterdata: "Meine Daten",
                resetSettings: "Einstellungen zurücksetzen",
                manageAccount: "User-Accout",
            },
            gildeReports: "Berichte",
            scoutcard: "ScoutCard",
            scoutcardRequests: "ScoutCard-Anfragen",
        },
        column: {
            actions: 'Aktionen',
            mobile_actions: 'Aktionen',
            download: 'Download',
        },
        error: {
            default: 'Fehler bei der Aktion',
            message: 'Fehler bei der Aktion: {{message}}',
            noPermission: 'Keine Berechtigung',
            noPermissionFor: 'Keine Berechtigung für {{entity}}',
            noPermissionForId: 'Keine Berechtigung für {{entity}} ({{id}})',
            record: {
                exists: 'Datensatz existiert bereits',
            },
            code: {
                MEMBERSHIP_ACTIVE_CONFLICT: 'Es gibt bereits eine Mitgliedschaft in dem Zeitraum',
                MEMBERSHIP_FULL_CONFLICT: 'Es darf nur eine Hauptmitgliedschaft geben',
                JOB_ORG_LEVEL: 'Organisationsebene der Funktion passt nicht zur Organisation',
                MEM_REL_IDENTICAL: 'Mitglied und Beziehungsperson sind identisch',
                SEC_ORG_TROOP: 'Organisation muss vom Type TROOP sein',
                SEC_SEC_SECTION: 'Stufe muss vom Typ SECTION sein',
                JOB_BOARD_UUID_REQUIRED: 'Gremium muss eine UUID haben',
                EDU_TRACK_REQUIRED: 'Ausbildungsplan muss angegeben sein',
                EDU_DESCRIPTION_REQUIRED: 'Beschreibung muss angegeben sein',
                MEMBER_DUPLICATE_SCOUTID: "Scout-ID ist bereits vergeben",
                USER_ALREADY_EXISTS_IN_KEYCLOAK: "Benutzerkonto existiert bereits - bitte verwende die Funktion Passwort vergessen um ein neues Passwort zu vergeben",
                MEMBER_NO_ACTIVE_MEMBERSHIP: "Es gibt keine aktive Mitgliedschaft - bitte wende dich an den SCOREG-Beauftragten deiner Organisation",
                MEMBER_MULTIPLE_ACTIVE_MEMBERSHIPS: "Es gibt mehrere aktive Mitgliedschaften - bitte wende dich an den SCOREG-Beauftragten deiner Organisation",
                MEMBER_ALREADY_HAS_PERMISSIONS: "Es gibt bereits Berechtigungen - bitte wende dich an den SCOREG-Beauftragten deiner Organisation",
                EMAIL_NOT_MATCHING_MEMBER: "Die E-Mail-Adresse stimmt nicht mit der des Mitglieds überein",
            },
            createMember: {
                duplicatesNotChecked: 'Duplikate nicht überprüft!',
            },
            membershipRequest: {
                alreadyFinished: 'Mitgliedschaftsanfrage wurde bereits bearbeitet',
            },
            NoPermissionError: 'Keine Berechtigung für den Datensatz',
            NotFoundError: 'Datensatz existiert nicht',
            listReport: {
                single: 'Es muss eine Liste ausgewählt werden',
                multi: 'Es müssen mehrere Listen ausgewählt werden',
            },
            phoneSyntax: 'Telefonnummer sollte im Format +zz yyyy xxxx oder 0xxx/yyyy sein',
            educationImport: 'Fehler beim Import der Ausbildungsschritte',

        },
        label: {
            noSelection: 'keine {{entity}}',
            index: {
                welcome: 'Willkommen',
                welcomeAnonymous: 'Willkommen bei SCOREG',
                selectOrganization: 'Organisation auswählen',
            },
            logout: 'Du wurdest automatisch ausgeloggt, da du länger inaktiv warst. Bitte melde dich erneut an.',
            createMember: {
                relatedMember: 'Familienmitglied zu {{lastname}} {{firstname}} anlegen',
                duplicatesFound: 'mögliche Duplikate gefunden',
                duplicatesChecked: 'Duplikate überprüft',
                createRelation: 'Beziehung anlegen',
                copyParentData: "Beziehungen (Familienmitglieder) übernehmen",
            },
            listGenerator: {
                federationJobs: 'Bundesfunktionen',
                divisionJobs: 'Landesfunktionen',
                troopJobs: 'Gruppenfunktionen',
                sectionJobs: 'Stufenfunktionen',
                sections: 'Stufen',
                organizations: 'Organisationen',
            },
            toolbarManagement: 'Ansicht',
            viewState: {
                saveAsNew: 'Als neue Ansicht speichern',
                overwriteExisting: 'Ansicht überschreiben',
                overwriteDeleteExisting: 'Ansicht auswählen',
                delete: 'Ansicht löschen',
            },
            member: {
                moreData: 'Weitere Daten',
            },
            memberFilter: {
                all: 'Alle',
                member: 'Mitglieder',
                contact: 'Kontakte',
                registered: 'Registrierung',
                section: 'Stufen',
                board: 'Gremien',
                jobs: 'Alle',
            },
            mainMembership: {
                fee: 'Mitgliedsbeitrag',
                fees: 'Mitgliedsbeiträge',
                newsletter: 'Zeitungsbezug',
                mailing: 'Zusendungen',
                calculated: 'berechnet',
                overwrite: 'überschrieben',
                fullpayer: 'Scout-ID Vollzahler',
                header: 'Aktuelle Mitgliedschaft',
            },
            registration: {
                snapshot: 'Registrierung',
                compare: 'Vergleich mit',
                noComparison: 'kein Vergleich',
                statistic: 'Statistik Registrierung',
                statisticCompare: 'Vergleich mit',
                difference: 'Differenz',
            },
            paginationButton: 'Seitenansicht',
            optimalPageSize: 'Seitengröße optimieren',
            noDynamicFields: 'Es werden keine Freifelder verwendet',
            scoutcard: {
                export: 'Scoutcard-Export',
            },
            migrations: {
                contactgroups: 'Kontaktgruppen - Status: {{migrated}}/{{total}}',
                lists: 'Listen - Status: {{migrated}}/{{total}}',
                events: 'Veranstaltungen - Status: {{migrated}}/{{total}}',
                dynamicFields: 'Freifelder - Status: {{migrated}}/{{total}}',
            }

        },
        message: {
            deleteAreYouSure: 'Sind Sie sicher, dass Sie den Datensatz löschen möchten?',
            apiKeyCreated: 'Dein API-Key wurde erstellt - bitte notieren, er kann nicht mehr angezeigt werden: {{apiKey}}',
            resetSettings: 'Einstellungen wurden zurückgesetzt',
            resetSettingsDescription: 'Es werden alle lokalen Einstellungen zurückgesetzt (Filter, Angezeigte Spalten, Spaltenbreiten, Sortierungen). Dies betrifft nur den aktuellen Browser. Gespeicherte Ansichten werden nicht gelöscht.',
            scoutcard: {
                export: {
                    success: 'Scoutcard-Export erfolgreich erstellt',
                    error: 'Fehler beim Erstellen des Scoutcard-Exports',
                },
                request: {
                    success: 'Scoutcard-Anfrage erfolgreich erstellt',
                    error: 'Fehler beim Erstellen der Scoutcard-Anfrage',
                }
            },
            membersCreated: '{{count}} Mitglieder wurden angelegt',
            uploadMembers: 'Achtung: Beim Hochladen werden nur neue Mitglieder angelegt. Vorhandene Mitglieder werden nicht aktualisiert. Es wird auch keine Duplikatsprüfung durchgeführt.',
            userCreated: 'Benutzerkonto wurde erstellt und eine E-Mail mit den der Anleitung zum Vergeben des Passworts versendet.',
            userCreatedError: 'Fehler beim Erstellen des Benutzerkontos: {{message}}',
            userUpdated: 'Benutzerkonto wurde aktualisiert.',
            resetMfaSuccess: 'MFA erfolgreich zurückgesetzt.',
            resetMfaError: 'Fehler beim Zurücksetzen der MFA.',
            dsgvoDeleted: 'Die Daten des Mitglieds wurden gemäß DSGVO gelöscht.',
            createUser: 'Nach Eingabe der Scout-ID und der E-Mail-Adresse wird ein Benutzerkonto erstellt und eine E-Mail mit der Anleitung zum Vergeben des Passworts versendet.',
        },
        enum: {
            scoutstate: {
                MEMBER_FULL: 'Vollmitglied',
                MEMBER_ADD: 'Zusatzmitglied',
                CONTACT: 'Kontakt',
            },
            memberRelation: {
                type: {
                    HUSBAND: 'Ehemann',
                    WIFE: 'Ehefrau',
                    SISTER: 'Schwester',
                    BROTHER: 'Bruder',
                    SIBLING: 'Geschwister',
                    MOTHER: 'Mutter',
                    FATHER: 'Vater',
                    PARENT: 'Eltern',
                    SON: 'Sohn',
                    DAUGHTER: 'Tochter',
                    KID: 'Kind',
                    PARTNER: 'Partner',
                    LEGAL_PARENT: 'Erziehungsberechtigter',
                    LEGAL_KID: 'Schützling',
                    CONTACT: 'Kontaktperson',
                    null: ''
                }
            },
            member: {
                sex: {
                    undefined: '',
                    MALE: "männlich",
                    FEMALE: "weiblich",
                    DIVERS: "divers",
                    ORG: "Organisation",
                    UNKNOWN: "unbekannt",
                }
            },
            organizationLevel: {
                undefined: '',
                TROOP: 'Gruppe',
                TROOP_other: 'Gruppen',
                DIVISION: 'Landesverband',
                DIVISION_other: 'Landesverbände',
                FEDERATION: 'Bundesverband',
                UNDEFINED: 'Organisation',
                ALL: 'Alle Ebenen',
                SECTION: 'Stufe',
                KOLONNE: 'Kolonne',
            },
            organizationLevelAbbreviation: {
                undefined: '',
                TROOP: 'Gruppe',
                DIVISION: 'LV',
                FEDERATION: 'BV',
                UNDEFINED: 'ORG',
            },
            organizationSystem: {
                PFADFINDER: 'Pfadfinder',
                GILDE: 'Gilde',
            },
            payment: {
                undefined: '',
                null: '',
                AUTO: 'automatisch',
                FULL: 'voll',
                REDUCED: 'reduziert',
                REDUCED2: 'reduziert 2',
                INDIVIDUAL1: 'individuell 1',
                INDIVIDUAL2: 'individuell 2',
                INDIVIDUAL3: 'individuell 3',
                FREE: 'befreit',
                PWA: 'PWA',
                EINZEL: 'Einzel',
                PAAR: 'Paar',
                MEMBER: 'Mitgliedsbeitrag',
                MEMBER_REG: 'Mitgliedsbeitrag + Registrierbeitrag',
                NONPAY: 'Nicht zahlend'
            },
            newsletter: {
                AUTO: 'automatisch',
                TRUE: 'ja',
                FALSE: 'nein',
                true: 'ja',
                false: 'nein',
            },
            mailing: {
                AUTO: 'automatisch',
                TRUE: 'ja',
                FALSE: 'nein',
                true: 'ja',
                false: 'nein',
            },
            boolean: {
                true: 'ja',
                false: 'nein',
            },
            registrationSnapshotType: {
                PRIMARY: 'Hauptregistrierung',
                SECONDARY: 'Nachregistrierung',
                REGULAR: 'Snapshot',
                DAILY: 'Aktuell',
                REG05: 'PPÖ Registrierung',
                SUMMARY: 'Gesamt (Haupt + Nachregistrierung)',
                MANUAL: 'Manuell erstellt',
            },
            registrationStatus: {
                REGISTERED_FULL: 'Vollmitglied',
                REGISTERED_ADD: 'Zusatzmitglied',
                REGISTERED_ELSE: 'In anderer Organisation registriert',
                NOT_REGISTERED: 'Nicht registriert',
                REGISTERED_INTERNAL: 'Intern',
                INACTIVE: 'Inaktiv',
                MISSING_FULL: 'Fehlende Vollmitgliedschaft',
            },
            changeType: {
                EXISTING: 'bestehend',
                NEW: 'neu registriert',
                DELETED: 'nicht mehr registriert',
                UPDATED: 'geändert',
            },
            weekday: {
                MO: 'Montag',
                DI: 'Dienstag',
                MI: 'Mittwoch',
                DO: 'Donnerstag',
                FR: 'Freitag',
                SA: 'Samstag',
                SO: 'Sonntag',
            },
            listType: {
                CAMP: 'Lager',
                HEIMSTUNDE: 'Heimstunde',
                EDUCATION: 'Ausbildung',
                CONTACTGROUP: 'Kontaktgruppe',
                MEETING: 'Sitzung',
                APPLICATION: 'Anmeldung',
                EVENT: 'Veranstaltung',
                OTHER: 'Sonstiges',
            },
            shareLevel: {
                OWN: 'Private Liste (keine Freigabe)',
                ORGANIZATION: 'Öffentliche Liste in eigener Organisation',
                MEMBER: 'Private Liste für Listenmitglieder',
                SETTINGS: 'Freigabe in Organisation gemäß Einstellungen',
                CHILD_PUBLIC: 'Freigabe in untergeordneten Organisationen gemäß Einstellungen (alle sichtbar)',
                CHILD_PRIVATE: 'Freigabe in untergeordneten Organisationen gemäß Einstellungen (nur eigene Mitglieder sichtbar)',
            },
            qualityError: {
                ERROR: 'Fehler',
                WARNING: 'Warnung',
            },
            active: {
                true: 'aktiv',
                false: 'inaktiv',
            },
            revisionType: {
                INSERT: 'Erstellt',
                UPDATE: 'Aktualisiert',
                DELETE: 'Gelöscht',
            },
            scoutcardExportType: {
                DAILY: 'Aktuell',
                DELTA: 'Differenz',
                FULL: 'Vollexport'
            },
            jobBoard: {
                SECTION: 'Stufe',
            },
            dynamicFieldDataType: {
                TEXT: 'Text',
                BOOL: 'Checkbox',
                DATE: 'Datum',
                NUMBER: 'Nummer',
                MEMBER: 'Mitglied',
            },
            permissionConfig: {
                inheritance: {
                    OWN: 'Eigene Daten',
                    ORGANIZATION: 'Aktuelle Organisation',
                    ALL_FEDERATION: 'Gesamter Verband (nur eigene Mitglieder)',
                    PARENT: 'Übergeordnete Organisationen (nur eigene Mitglieder)',
                    CHILDREN: 'Untergeordnete Organisationen',
                    DIV: 'Landesverband',
                    SECTION: 'Zugeordnete Stufe',
                }
            }
        },
        report: {
            name: {
                listHeader_listMember: 'Liste',
                memberships: 'Mitgliedschaften',
                sections: 'Stufen',
                jobs: 'Funktionen',
                awards: 'Verleihungen',
                registration: 'Registrierung',
                education: 'Ausbildung',
                qualityMember: 'Qualitätsanalyse Mitglieder',
                qualityAddress: 'Qualitätsanalyse Adressen',
                organizationEducation: 'Ausbildungsschritte',
                postreceiver: 'Postempfänger',
                incomingMembershipRequests: 'Eingehende Mitgliedschaftsanfragen',
                organizations: 'Organisationen',
                permissionConfig: 'Berechtigungen',
            }
        },
        helperText: {
            ScoutIdAutocomplete: 'Name oder Scout-ID (für exakte Suche)',
            organization: {
                color: 'Farbe der Organisation (Format: #RRGGBB)',
            },
            member: {
                dayOfRetirement: 'Nur setzen, wenn Mitglied endgültig aus der Pfadfinderbewegung ausscheidet.',
            },
        },
        visibility: {
            organizationOverview: {
                abbreviation: 'true',
            },
            member: {
                taxId: 'false'
            }

        },
        defaultValue: {
            member: {
                country: 'Österreich',
            }
        },
        permissionConfig: {
            Member: {
                portrait: 'Foto',
                phone: 'Telefonnummern',
                email: 'E-Mail-Adressen',
                publicDescription: 'Öffentliche Notizen',
                privateDescription: 'Private Notizen',
                dates: 'Datumswerte',
                export: 'Exportieren',
                tableEdit: 'Tabelle bearbeiten',
                dsgvoDelete: 'DSGVO Löschen',
                contextMenu: 'Kontextmenü',
                user: 'Benutzerkonto',
            },
            Organization: {
                dynamicFields: 'Freifelderdefinition Organisation',
                logo: 'Logo',
                scarf: 'Halstuch',
                sectionTimes: 'Heimstundenzeiten',
                migrateContactgroups: 'Kontaktgruppen migrieren',
                migrateLists: 'Listen migrieren',
                migrateEvents: 'Veranstaltungen migrieren',
                migrateDynamicFields: 'Freifelder migrieren',
                OrganizationOverview: 'Organisationsübersicht',
                MemberSectionBulkUpdate: 'Überstellung',
                MemberFeeCleared: 'Mitgliedsbeitrag bezahlt zurücksetzen',
                PfadfinderReports: 'Berichte',
                GildeReports: 'Berichte',
                export: 'Exportieren',
                Migration: 'Datenmigrationen',
                PostreceiverOverview: 'Postempfänger Übersicht',
                MedusaImport: 'Medusa Import',
                EducationUpload: 'Ausbildung importieren',
                scoutcardView: 'ScoutCard',
                scoutcardRequest: 'ScoutCard-Anfragen',
                scoutcardExport: 'ScoutCard-Exporte',
                scoutcardRecord: 'ScoutCard-Datensätze',
            },
            MembershipList: {
                CURRENT: 'Liste: Aktuelle Mitglieder',
                REGISTERED: 'Liste: Registrierte Mitglieder',
                MEMBERS: 'Liste: Alle Mitglieder',
                CONTACTS: 'Liste: Kontakte',
                INACTIVE: 'Liste: Inaktive Mitglieder',
                TOTAL: 'Liste: Alle Einträge',
                SECTION: 'Liste: Stufenmitglieder',
                BOARD: 'Liste: Gremienmitglieder',
                CHILD_ORGANIZATION: 'Liste: Mitglieder untergeordneter Organisationen',
                HIERARCHY: 'Liste: Mitglieder in der Organisationshierarchie',
            },
            Report: {
                Pfadfinderlebenslauf: 'Bericht: Pfadfinderlebenslauf',
                Datenblatt: 'Bericht: Datenblatt',
                Pfadfinderlebenslauf_section: 'Bericht: Pfadfinderlebenslauf nach Stufen',
                Datenblatt_section: 'Bericht: Datenblatt nach Stufen',
                registration_finance_troop: "Bericht: Beitragseinnahmen Gruppe",
                registration_finance_division: "Bericht: Beitragseinnahmen Landesverband",
                registration_finance_federation: "Bericht: Beitragseinnahmen Bundesverband",
                registration_job_section_division: "Bericht: Funktionsübersicht Landesverband",
                registration_job_section_federation: "Bericht: Funktionsübersicht Bundesverband",
                registration_statistic_federation: "Bericht: Statistik Bundesverband",
                registration_history: "Bericht: Registrierung Historie (Gruppen)",
                registration_history_troops: "Bericht: Registrierung Historie",
                registration_statistic_federation_troops: "Bericht: Statistik Bundesverband - Gruppen",
                registration_statistic_federation_divisions_history: "Bericht: Statistik aller jemals registrierten Personen",
                registration_statistic_federation_divisions_ideell: "Bericht: Statistik aller jemals erfassten Personen",
                registration_statistic_federation_divisions: "Bericht: Statistik Bundesverband - LV",
                scoreg_abrechnung: "Bericht: SCOREG Abrechnung",
                division_newsletter: "Bericht: Landesverband Zeitungsbezug",
                division_newsletter_orgrel: "Bericht: Landesverband Zeitungsbezug mit verknüpften Organisationen",
                division_newsletter_fee: "Bericht: Landesverband Zeitungsbezug mit Mitgliedsbeitrag",
                list_multi: "Bericht: Listenübersicht (mehrere Listen)",
                ppoe_federation_newsletter: "Bericht: Bundesverband PPÖ Zeitungsbezug",
            },
            Chart: {
                sections: 'Statistik Stufen',
                boards: 'Statistik Gremien',
                history: 'Statistik Historie',
                children: 'Statistik Untergeordnete Organisationen',
            }
        }
    }
}